module.exports = __webpack_public_path__ + "img/negz.93ddca20.jpg";